module.exports = __webpack_public_path__ + "img/1-5.73041cad.svg";